<template>
  <div class="user-center">
    <div class="user-rate" v-if="employeeQuota && fnfQuota">
      {{ $t('Available Rate') }}<br/>{{ $t('Employee Rate') }}{{employeeQuota}} | {{ $t('Friends & Family Rate') }}{{fnfQuota}}
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick" class="mobile-tabs">
      <el-tab-pane :label="$t('MY BOOKING')" name="myBooking" :disabled="isForceChange">
        <div class="tabs-content" v-loading="fullLoading">
          <div class="tabs-header">
            <div class="title">
              {{$t('My Booking')}}
            </div>
            <router-link :to="{name:'Home'}" class="back-link">
              {{$t('Back to Homepage')}}
            </router-link>
          </div>
          <div class="content">
            <div class="content-title">
              <div>{{ $t('Available Rate') }}</div>
              <div>{{ $t('Employee Rate') }}{{employeeQuota}}</div>
              <div>{{ $t('Friends & Family Rate') }}{{fnfQuota}}</div>
            </div>
            <div class="content-container">
              <!-- max-height="260" -->
              <el-table :data="tableData" v-if="tableData.length>0" @sort-change="sortChange">
                <el-table-column prop="guestName" :label="$t('Guest Name')" width="135"></el-table-column>
                <el-table-column prop="arrival" :label="$t('Arrival Date')" width="135" sortable='custom'></el-table-column>
                <el-table-column prop="departure" :label="$t('Departure Date')" width="150" sortable='custom'></el-table-column>
                <el-table-column prop="room_type_name" :label="$t('Room Type')" width="145"></el-table-column>
                <el-table-column prop="rate_name" :label="$t('Rate Name')" width="140"></el-table-column>
                <el-table-column prop="create_time" :label="$t('Booking Date')" width="135" sortable='custom'></el-table-column>
                <el-table-column prop="status" :label="$t('Status')" width="110" sortable='custom'></el-table-column>
                <el-table-column prop="order_id" :label="$t('Confirmation Code')" width="165" sortable='custom'></el-table-column>
                <el-table-column>
                  <template slot-scope="scope">
                    <router-link :to="{name:'Information', query: {orderId: scope.row.order_id}}" class="order-link">
                      {{ $t('View') }}
                    </router-link>
                  </template>
                </el-table-column>
              </el-table>
              <p v-else>{{$t('No items')}}</p>
              <div class="mobile-table">
                <el-descriptions :title="tableColumn.guestName" :column="1" v-for="(tableColumn, index) of tableData" :key="index">
                    <el-descriptions-item :label="$t('Arrival Date')">{{tableColumn.arrival}}</el-descriptions-item>
                    <el-descriptions-item :label="$t('Departure Date')">{{tableColumn.departure}}</el-descriptions-item>
                    <el-descriptions-item :label="$t('Room Type')">{{tableColumn.room_type_name}}</el-descriptions-item>
                    <el-descriptions-item :label="$t('Rate Name')">{{tableColumn.rate_name}}</el-descriptions-item>
                    <el-descriptions-item :label="$t('Booking Date')">{{tableColumn.create_time}}</el-descriptions-item>
                    <el-descriptions-item :label="$t('Status')">{{tableColumn.status}}</el-descriptions-item>
                    <el-descriptions-item :label="$t('Confirmation Code')">{{tableColumn.order_id}}</el-descriptions-item>
                    <el-descriptions-item>
                      <router-link :to="{name:'Information', query: {orderId: tableColumn.order_id}}" class="order-link">
                        {{ $t('View') }}
                      </router-link>
                    </el-descriptions-item>
                </el-descriptions>
              </div>
              <div class="pager" v-if="last_page > 1">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  @current-change="changePage"
                  :total="total">
                </el-pagination>
            </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('CHANGE PASSWORD')" name="changePassword">
        <div class="tabs-content">
          <div class="reset-wrapper" style="margin-top: 32.5px;">
            <div class="reset-title">{{$t('Reset Password')}}</div>
            <el-form :model="changeForm" label-position="top" status-icon :rules="rules" ref="changeForm" label-width="100px" class="reset-form" v-loading="fullLoading">
              <el-form-item :label="$t('Current Password')" prop="currentPSW">
                <el-input show-password v-model="changeForm.currentPSW" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item :label="$t('New Password')" prop="newPSW">
                <el-input show-password v-model="changeForm.newPSW" autocomplete="off" @input="inputPassword"></el-input>
              </el-form-item>
              <el-form-item :label="$t('Confirm New Password')" prop="confirmNewPSW">
                <el-input show-password v-model="changeForm.confirmNewPSW" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item class="submitWrapper">
                <el-button type="primary" @click="submitForm()" class="submitBtn">{{ $t('CHANGE PASSWORD') }}</el-button>
                <div class="passwordTip" :class="{error: !isValidPSW}">{{ $t('Between 8 and 20 characters') }}</div>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
  export default {
    data() {
      const validatePassword = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('please input password')))
        } else {
          callback()
        }
      }
      const validateCurrentPassword = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('Please input the current password')))
        } else {
          callback()
        }
      }
      const validateConfirmPassword = (rule, value, callback) => {
        if(value === '' || value !== this.changeForm.newPSW) {
          callback(new Error(this.$t('Passwords do not match')))
        } else {
          callback()
        }
      }
      return {
        activeName: 'myBooking',
        isForceChange: false,
        fullLoading: false,
        tableData: [],
        booking_list: [],
        origin_list: [],
        last_page: 1,
        page: 1,
        total: 1,
        changeForm: {
          currentPSW: '',
          newPSW: '',
          confirmNewPSW: '',
        },
        rules: {
          currentPSW: [{ validator: validateCurrentPassword, trigger: 'blur' }],
          newPSW: [
            {validator: validatePassword, trigger: 'blur'},
            {pattern: this.$store.state.pattern, message: ' '},
            ],
          confirmNewPSW: [{ validator: validateConfirmPassword}],
        },
        isValidPSW: true,
      };
    },
    methods: {
      initTable() {
        this.fullLoading = true
        this.axios.get('/api/employee/order/list',{
          params: {
            ...this.$route.query,
          }
        })
        .then((res) => {
          if(res.code == 200) {
            let resTableData = []
            res.data.data.map((data) => {
              resTableData.push(Object.assign({}, data, {guestName: data.first_name+ ' ' + data.last_name}))
            })
            this.origin_list = resTableData.slice()
            this.booking_list = resTableData.slice()
            this.changePage(1)
            this.last_page = res.data.last_page
            this.total = res.data.total
          } else {
            this.$alert(res.msg, {
              confirmButtonText: this.$t('CLOSE'),
              center: true,
            })
          }
        }).finally(() => {
          this.fullLoading = false
        })
      },
      changePage(page) {
        this.page = page
        this.tableData = this.booking_list.slice(10 * (page -1), 10 * page)
      },
      sortChange({order, prop}) {
        switch (order) {
          case 'ascending':
            this.ascendSort(prop)
            break;
          case 'descending':
            this.descendSort(prop)
            break;
          default:
            this.noSort()
            break
        }
      },
      ascendSort(prop) {
        switch (prop) {
          case 'order_id':
            this.booking_list.sort((a, b) => {
              var value1 = +a[prop];
              var value2 = +b[prop];
              return value2 - value1;
            })
            break;
          case 'status':
            this.booking_list.sort((a, b) => {
              var value1 = a['status_code'];
              var value2 = b['status_code'];
              return value2 - value1;
            })
            break;
          case 'arrival':
            this.booking_list.sort((a, b) => {
              var value1 = a['arrival_time'];
              var value2 = b['arrival_time'];
              return value2 - value1;
            })
            break;
          case 'departure':
            this.booking_list.sort((a, b) => {
              var value1 = a['departure_time'];
              var value2 = b['departure_time'];
              return value2 - value1;
            })
            break;
          case 'create_time':
            this.booking_list.sort((a, b) => {
              var value1 = a['create_time_time'];
              var value2 = b['create_time_time'];
              return value2 - value1;
            })
            break;
          default:
            break;
        }
        this.changePage(this.page)
      },
      descendSort(prop) {
        switch (prop) {
          case 'order_id':
            this.booking_list.sort((a, b) => {
              var value1 = +a[prop];
              var value2 = +b[prop];
              return value1 - value2;
            })
            break;
          case 'status':
            this.booking_list.sort((a, b) => {
              var value1 = a['status_code'];
              var value2 = b['status_code'];
              return value1 - value2;
            })
            break;
          case 'arrival':
            this.booking_list.sort((a, b) => {
              var value1 = a['arrival_time'];
              var value2 = b['arrival_time'];
              return value1 - value2;
            })
            break;
          case 'departure':
            this.booking_list.sort((a, b) => {
              var value1 = a['departure_time'];
              var value2 = b['departure_time'];
              return value1 - value2;
            })
            break;
          case 'create_time':
            this.booking_list.sort((a, b) => {
              var value1 = a['create_time_time'];
              var value2 = b['create_time_time'];
              return value1 - value2;
            })
            break;
          default:
            break;
        }
        this.changePage(this.page)
      },
      noSort() {
        this.booking_list = this.origin_list.slice()
        this.changePage(this.page)
      },
      handleClick(tab) {
        if(tab.index == 0) {
          this.initTable()
        }
      },
      submitForm() {
        this.$refs.changeForm.validate((valid) => {
          if (valid) {
            this.fullLoading = true
            const changeData = {
              old_password: this.changeForm.currentPSW,
              new_password: this.changeForm.newPSW,
              password_confirmation: this.changeForm.confirmNewPSW,
            }
            this.axios.post('/api/employee/auth/changePwd', changeData)
              .then((res) => {
                if (res.code === 200) {
                  // 修改成功
                  localStorage.isForceChange = false
                  if(this.isForceChange) {
                    this.login(res.data.account, changeData.new_password, res.msg)
                    localStorage.removeItem('isForceChange')
                  } else {
                    this.$alert(res.msg, {
                      confirmButtonText: this.$t('CLOSE'),
                      center: true,
                      callback: () => {this.$router.push({name: 'Home'})}
                    })
                  }
                } else {
                  this.$alert(res.msg, {
                      confirmButtonText: this.$t('CLOSE'),
                      center: true,
                  })
                }
              }).finally(() => {
              this.fullLoading = false
            })
          } else {
            return false;
          }
        });
      },
      login(account, password , msg) {
        this.fullLoading = true
        const loginData = { account, password, }
        this.axios.post('/api/employee/auth/login', loginData)
          .then((res) => {
            if (res.code === 200) {
              localStorage.username = res.data.first_name+' '+ res.data.last_name
              localStorage.employee_quota = res.data.employee_quota
              localStorage.employee_rate = JSON.stringify(res.data.employee_rate)
              localStorage.fnf_quota = res.data.fnf_quota
              localStorage.fnf_rate = JSON.stringify(res.data.fnf_rate)
              this.$store.commit('stateChange', {k: 'username', v: res.data.first_name+' '+ res.data.last_name})
              this.$store.commit('stateChange', {k: 'employeeQuota', v: res.data.employee_quota})
              this.$store.commit('stateChange', {k: 'employeeRate', v: res.data.employee_rate})
              this.$store.commit('stateChange', {k: 'fnfQuota', v: res.data.fnf_quota})
              this.$store.commit('stateChange', {k: 'fnfQuota', v: res.data.fnf_rate})
              // 是否需要强制改密码
              if(res.data.force_change_pwd == true) {
                // 提示并跳转页面强制修改密码
                localStorage.isForceChange = true
                this.$alert(this.$t('Password must be changed'), {
                  confirmButtonText: this.$t('CLOSE'),
                  center: true,
                  callback: () => {this.$router.push({name: 'UserCenter'})}
                })
              } else {
                this.$alert(msg, {
                  confirmButtonText: this.$t('CLOSE'),
                  center: true,
                  callback: () => {this.$router.push({name: 'Home'})}
                })
              }
            } else {
              this.$alert(res.msg, {
                  confirmButtonText: this.$t('CLOSE'),
                  center: true,
              })
            }
          }).finally(() => {
          this.fullLoading = false
        })
      },
      inputPassword() {
        this.$refs.changeForm.validateField('newPSW', (valid) => {
          valid ? this.isValidPSW=false : this.isValidPSW=true
        })
      }
    },
    computed: {
      employeeQuota() {
        return localStorage.employee_quota || this.$store.state.employeeQuota
      },
      fnfQuota() {
        return localStorage.fnf_quota || this.$store.state.fnfQuota
      },
    },
    created() {
      if(localStorage.isForceChange) {
        if(JSON.parse(localStorage.isForceChange) == true) {
          this.isForceChange = true
          this.activeName = 'changePassword'
        }
      }
      if (!this.isForceChange) {
        this.initTable()
      }
    }
  };
</script>
